<template>
  <div class="not-found">
    <div class="background-animation"></div>
    <div class="content-container">
      <div class="error-card">
        <div class="error-icon">
          <div class="icon-circle">
            <span class="icon-404">404</span>
          </div>
        </div>
        <h1 class="error-title">页面不存在</h1>
        <p class="error-description">
          抱歉，您访问的页面不存在，<span class="countdown">{{ time }}</span>秒后自动返回首页
        </p>
        <div class="button-group">
          <el-button type="primary" size="medium" @click="goBack" class="back-button">
            <i class="el-icon-s-home"></i> 前往首页
          </el-button>
          <el-button type="text" size="medium" @click="goHistory" class="history-button">
            <i class="el-icon-back"></i> 返回上一页
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'notFound',
  data () {
    return {
      time: 5,
      timer: null
    }
  },
  methods: {
    goBack () {
      this.$router.replace('/index').catch(() => {})
    },
    goHistory () {
      this.$router.go(-1)
    }
  },
  created () {
    this.timer = setInterval(() => {
      this.time--;
      if (this.time <= 0) {
        clearInterval(this.timer);
        this.$router.replace('/index').catch(() => {})
      }
    }, 1000)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>
<style scoped lang="scss">
.not-found {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #409EFF 0%, #1e88e5 50%, #0f172a 100%);
  background-size: 400% 400%;
  animation: gradientBG 8s ease infinite;
}

.background-animation {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
    animation: rotate 20s linear infinite;
  }
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: 
      radial-gradient(circle at 20% 30%, rgba(64, 158, 255, 0.3) 0%, transparent 20%),
      radial-gradient(circle at 80% 70%, rgba(30, 136, 229, 0.3) 0%, transparent 20%);
    animation: float 6s ease-in-out infinite;
  }
}

.content-container {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 20px;
}

.error-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 24px;
  padding: 60px 50px;
  text-align: center;
  box-shadow: 
    0 25px 50px -12px rgba(0, 0, 0, 0.25),
    0 0 0 1px rgba(255, 255, 255, 0.1) inset;
  max-width: 500px;
  width: 100%;
  animation: slideUp 0.6s ease-out;
}

.error-icon {
  margin-bottom: 30px;
  .icon-circle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 140px;
    height: 140px;
    background: linear-gradient(135deg, #409EFF 0%, #1e88e5 100%);
    border-radius: 50%;
    box-shadow: 
      0 10px 30px rgba(64, 158, 255, 0.4),
      0 0 0 8px rgba(64, 158, 255, 0.1);
    animation: pulse 2s ease-in-out infinite;
    .icon-404 {
      font-size: 48px;
      font-weight: 800;
      color: white;
      letter-spacing: 2px;
      text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    }
  }
}

.error-title {
  font-size: 28px;
  color: #1e3a5f;
  margin-bottom: 15px;
  font-weight: 700;
}

.error-description {
  font-size: 16px;
  color: #666;
  margin-bottom: 35px;
  line-height: 1.6;
  .countdown {
    color: #409EFF;
    font-weight: 700;
    font-size: 20px;
    animation: bounce 1s ease-in-out infinite;
  }
}

.button-group {
  display: flex;
  gap: 15px;
  justify-content: center;
  flex-wrap: wrap;
}

.back-button {
  background: linear-gradient(135deg, #409EFF 0%, #1e88e5 100%);
  border: none;
  border-radius: 12px;
  padding: 12px 30px;
  font-size: 15px;
  font-weight: 600;
  box-shadow: 0 4px 15px rgba(64, 158, 255, 0.4);
  transition: all 0.3s ease;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(64, 158, 255, 0.5);
  }
  &:active {
    transform: translateY(0);
  }
}

.history-button {
  color: #409EFF;
  font-size: 15px;
  font-weight: 500;
  &:hover {
    color: #1e88e5;
  }
}

@keyframes gradientBG {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

@keyframes rotate {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
}

@keyframes slideUp {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 
      0 10px 30px rgba(64, 158, 255, 0.4),
      0 0 0 8px rgba(64, 158, 255, 0.1);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 
      0 15px 40px rgba(64, 158, 255, 0.5),
      0 0 0 12px rgba(64, 158, 255, 0.15);
  }
}

@keyframes bounce {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

@media (max-width: 768px) {
  .error-card {
    padding: 40px 30px;
    border-radius: 20px;
  }
  .error-title {
    font-size: 24px;
  }
  .error-description {
    font-size: 14px;
  }
  .icon-circle {
    width: 120px !important;
    height: 120px !important;
    .icon-404 {
      font-size: 40px !important;
    }
  }
}
</style>
